/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import Header from "@gcloud-npm/next12.components.header-r";
import Footer from "@gcloud-npm/next12.components.footer";
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import { actions as mainActions } from "@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-r";
import TextInfo, {
  TEXT_INFO_ALIGN,
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_SIZE
} from '@gcloud-npm/next12.components.text-info';
import MetaData from '@gcloud-npm/next12.app-controller.meta-data';
import { getDeviceKindDependsOnViewPort } from '@gcloud-npm/next12.utils.common';
import ModuloBanner from "@components/ModuloBanner";
import Modal from "@components/Modal";
import LegalsModal from "@components/LegalsModal";
import ModuloCaracteristicas from "@components/ModuloCaracteristicas";
import ModuleFeatureISR from "@components/ModuloFeatureISR";
import ModuloFAQ from "@components/ModuloFAQ";
import ModuloTitle from "@components/ModuloTitle";
import ModuloPlan from "@components/ModuloPlan";
import ModuloPasos from "@components/ModuloPasos";
import ModuloContratar from "@components/ModuloContratar";
import ModuloOpiniones from "@components/ModuloOpiniones";
import ModuloVideos from "@components/ModuloVideos";
import CustomSlider from "@components/CustomSlider"
import StickyBarComponent from "@components/StickyBarComponent";
import { END } from "redux-saga";
import { wrapper } from "@/store";
import { 
  DATA_MODULE_BANNER,
  MOVISTAR_SALUD_CARACTERISTICA,
  MODULO_DETALLES,
  COMERCIAL_CONDITIONS,
  VENTAJAS,
  LISTADO_FAQS, 
  MODULO_SERVICIOS_ADICIONALES,
  MODULO_ESPECIALIDADES,
  MODULO_APPS,
  MODULO_PASOS, 
  MODULO_TESTIMONIOS,
  MODULO_OPINIONS,
  TABS_IDS } from "@/utils/constans";

const MovistarSalud = ({ breadcrumbsProps, headerProps, seoInfo }) => {
    const dispatch = useDispatch();
    const [device, setDevice] = useState('pc');
    useEffect(() => {
      setDevice(getDeviceKindDependsOnViewPort());
      dispatch(
        mainActions.setCurrentSeo(seoInfo)
      );
    }, []);

    const taggingInfoBannerSalud = {
      componentName: 'MEDICOONLINE',
      componentProduct: 'ModuloBanner',
      componentVariation: '',
    }

    const taggingInfoComercialConditions = {
        componentName: 'ComercialConditionsSalud',
        componentVariation: 'all',
        componentProduct: '',
    };
    const taggingInfoFaqs = {
      componentName: 'MovistarSaludFaqs',
      componentVariation: 'all',
      componentProduct: '',
    };
    const taggingInfoStickyBar = {
      componentName: 'MovistarSaludStickyBar',
      componentVariation: 'all',
      componentProduct: '',
    }

    const handleModal = (defaultTab = TABS_IDS.PLAN_PERSONAL) => {
      dispatch(
        modalActions.addModal({
          type: 'MODAL',
          id: 'kindUser',
          Element2Show: Modal,
          modalProps: {
            contentPosition: 'center--center',
            opacityLayoutColor: 'black05',
            inSceneEffect: 'fadeInBottom',
            outSceneEffect: 'fadeOutBottom',
            contentInsideContainer: false,
            closeByClickingOutside: true,
          },
          elementProps: {
            defaultValue: defaultTab
          }
        })
      );
    };

    const handleLegalsModal = () => {
        dispatch(
          modalActions.addModal({
            type: 'MODAL',
            id: 'legalConditionsModal',
            Element2Show: LegalsModal,
            modalProps: {
              closeByClickingOutside: true,
              contentPosition: 'right--top',
              inSceneEffect: 'fadeIn',
              outSceneEffect: 'fadeOut',
              contentInsideContainer: false,
              opacityLayoutColor: 'darkblue',
            },
            elementProps: {
              title: COMERCIAL_CONDITIONS.title,
              description: COMERCIAL_CONDITIONS.description,
              taggingInfo: taggingInfoComercialConditions,
            },
          })
        );
      };

  return (
    <>
    
      <MetaData seoInfo={seoInfo} />
      <Header {...breadcrumbsProps} {...headerProps} />
      <div>
        <ModuloBanner
            data={DATA_MODULE_BANNER(handleLegalsModal, handleModal)}
            taggingInfo={taggingInfoBannerSalud}
        />
        <ModuleFeatureISR 
          list={MOVISTAR_SALUD_CARACTERISTICA}
        />
        <ModuloCaracteristicas 
            title='Ventajas de Movistar Salud'
            featureList={VENTAJAS}
        />
        
        <div className="containerDetails">
          <ModuloTitle
            title='Movistar Salud en detalle'
            textAlign={TEXT_INFO_ALIGN.LEFT}
          />
          <ModuleFeatureISR 
            list={MODULO_DETALLES}
          />
        </div>
        <ModuleFeatureISR 
          list={MODULO_SERVICIOS_ADICIONALES}
        />
        <ModuleFeatureISR 
          list={MODULO_ESPECIALIDADES}
        />
        
        <div className="containerOpinions">
          <ModuloTitle
            title='Qué piensan nuestros pacientes'
          />
          <TextInfo
            text='Compartimos las opiniones de pacientes de Movistar Salud en el AppStore y Google Play'
            kind={TEXT_INFO_KIND.PARAGRAPH}
            align={TEXT_INFO_ALIGN.CENTER}
            color={TEXT_INFO_COLOR.GREY_4}
            size={TEXT_INFO_SIZE.TITLE7}
            fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
            className="subtitleOpinions"
          />
          <ModuloOpiniones
            listOpinions={MODULO_OPINIONS}
            settings={{
              dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: device === 'pc' ? 3: 1,
              slidesToScroll: 1,
            }}
          />
          <ModuloTitle
            title='Testimonios'
            textAlign={TEXT_INFO_ALIGN.LEFT}
          />
          <ModuloVideos
            listVideos={MODULO_TESTIMONIOS}
            settings={{
              dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: device === 'pc' ? 4: 1,
              slidesToScroll: 1,
            }}
          />
        </div>
        <ModuleFeatureISR 
          list={MODULO_APPS(device)}
          customStyle
        />
        <ModuloFAQ
          faqs={LISTADO_FAQS}
          title='Preguntas frecuentes'
          taggingInfo={taggingInfoFaqs}
        />
      </div>
      <Footer />
      
      <style jsx>
        {`
          .containersPlans {
            margin-bottom: 60px;
            margin-top: 55px;
            :global(.slick-dots li.slick-active button:before) {
              color: #019df4;
            }
          }

          .containerDetails {
            background: #F5F5F5;
            padding: 60px 0;
          }

          .containerSteps {
            background: #019DF4;
            padding: 60px 0;
            margin-top: 60px;
          }

          .containerOpinions {
            background: #F5F5F5;
            padding: 60px 0;
            margin-top: 60px;
            :global(.subtitleOpinions) {
              margin: 15px 0;
              font-size: 16px;
            }
          }

          .containerContract {
            background: #F5F5F5;
            padding: 60px 0;
          }

          :global(.slick-slide > div) {
            margin-right: 20px;
          }

          @media screen and (max-width: 768px) {
            :global(.slick-slide > div) {
              margin-right: 0px;
            }
          }
        `}
      </style>
    </>
  );
};

export default MovistarSalud;

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
 
  const modules = await Promise.all([
    await import("@gcloud-npm/adabyron.misc.get-static-content"),
    await import("@gcloud-npm/normalizers.components-header.sections"),
    await import(
      "@gcloud-npm/normalizers.components-header.breadcrumbs"
    ),
    await import("@gcloud-npm/next12.app-controller.reducers-sagas.header-reducer-r"),
    await import("@gcloud-npm/adabyron.custo.get-seo"),
  ]);
  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;
  const getSeo = modules[4].default;
  const context = store.getState().main.context

  const seoInfo = await getSeo({
    context,
    location: `www.movistar.es/particulares/salud/telemedicina-medico-online`,
  });
  // HEADER USUAL PROPS
  const urlBreadcrumbs = "/static/json/header/breadcrumbs.json";
  const breadcrumbsInfoJson = await getStaticContent({
    resourcePath: urlBreadcrumbs,
    context,
  });
  const url = "/particulares/salud/telemedicina-medico-online";
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  console.log('breadcrumbsProps', { breadcrumbsProps })
  const headerInfoJson = await getStaticContent({
    resourcePath: "/static/json/header/header_plan_r.json",
    context,
  });
// HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));
   store.dispatch(headerActions.getFooterInfo({ pathname: "/particulares/salud/telemedicina-medico-online" }));
  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      headerProps,
      breadcrumbsProps,
      seoInfo,
}
}
});
